module.exports = __webpack_public_path__ + "assets/assets/images/info/icon-tooth-search.71097ced.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/info/icon-tooth-search.svg
// module id = 220
// module chunks = 0